import { Rest } from 'utilities/rest';
import * as ActionCreator from 'utilities/action.creator';
import { $failure, $requesting, $success } from '../form/action';

export const MODULE = 'Connect';

const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, 'reset', () =>
  $reset.action()
);

export const $confirm = ActionCreator.Async(MODULE, 'Confirm', (payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.POST(`${API_URL}/partner/connect`, payload)
      .then((response) => {
        dispatch($confirm.success({ response: response }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $save = ActionCreator.Default(MODULE, 'Save', (payload) => {
  return (dispatch) => {
    dispatch($save.action({ payload }));
    return true;
  };
});
